export const facility = {
  namespaced: true,
  state: {
    overviewSearch: null,
    contractSearch: null,
    roleSearch: null,
    processSearch: null,
    documentationsSearch: null,
    cardView: true,
    toggleValue: null
  },
  mutations: {
    storeFacilityOverviewSearch(state, search) {
      state.overviewSearch = search;     
    },
    storeFacilityContractSearch(state, search) {
      state.contractSearch = search;
    },
    storeFacilityRoleSearch(state, search) {
      state.roleSearch = search;
    },    
    storeFacilityProcessSearch(state, search) {
      state.processSearch = search;
    },
    storeFacilityDocumentationsSearch(state, search) {
      state.documentationsSearch = search;
    },
    storeCardViewState(state, search) {
      state.cardView = search;
    },
    storeToggleValue(state, value) {
      state.toggleValue = value;
    }
  }
}
